import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import { PlanListWrapper } from './plan-list/PlanList'
import AddPlan from './plan-form/AddPlan'
import { EditPlanWrapper } from './plan-form/EditPlanWrapper'

const planBreadcrumbs: Array<PageLink> = [
  {
    title: 'Plan Management',
    path: '/plan',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const PlanPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/list'
          element={
            <>
              <PageTitle breadcrumbs={planBreadcrumbs}>Plan List</PageTitle>
              <PlanListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='list' />} />
      <Route
        path='/add'
        element={
          <>
            {' '}
            <PageTitle breadcrumbs={planBreadcrumbs}>Plan Add</PageTitle>
            <AddPlan />
          </>
        }
      />
      <Route
        path='/edit/:id'
        element={
          <>
            <PageTitle breadcrumbs={planBreadcrumbs}>Plan Edit</PageTitle>
            <EditPlanWrapper />
          </>
        }
      />
    </Routes>
  )
}

export default PlanPage
